export const EXTERNAL_CHAT_BUTTON_ROOT_SELECTOR = 'li.chat-list-novachat';

export const EXTERNAL_CHAT_BUTTON_SELECTOR = '.js-openNovaChat';
